module.exports = __webpack_public_path__ + "img/开启关闭.e559d8d2.svg";